module.exports = "<hot-table [rowHeaderWidth]=\"350\" [manualColumnResize]=\"true\" [colWidths]=\"300\" [autoColumnSize]=\"true\" [startRows]=\"35\" [minSpareRows]=\"0\" [height]=\"600\" [rowHeaders]=\"rowHeaders\" [columns]=\"columns\" [data]=\"data\" hotId=\"Configuration\">\n</hot-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/configuration/configuration.component.html
// module id = ./src/app/configuration/configuration.component.html
// module chunks = main